import { render, staticRenderFns } from "./LockScreen.vue?vue&type=template&id=0671a7b2&scoped=true"
import script from "./LockScreen.vue?vue&type=script&lang=ts"
export * from "./LockScreen.vue?vue&type=script&lang=ts"
import style0 from "./LockScreen.vue?vue&type=style&index=0&id=0671a7b2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0671a7b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0671a7b2')) {
      api.createRecord('0671a7b2', component.options)
    } else {
      api.reload('0671a7b2', component.options)
    }
    module.hot.accept("./LockScreen.vue?vue&type=template&id=0671a7b2&scoped=true", function () {
      api.rerender('0671a7b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LockScreen.vue"
export default component.exports